class Sidebar {
    constructor() {
        this.svg = document.querySelector('.svg-progress');
        this.progressBar = document.querySelector('.counter-progress-bar');
        this.pct = document.querySelector('.pct');
        this.sidebarNav = document.querySelector('.sidebar-nav');
        this.contentNavLinks = document.querySelector('.content-nav-links');

        if (this.progressBar) {
            this.totalLength = this.progressBar.getTotalLength();
        }

        this.init();
    }

    init() {
        if (this.svg && this.progressBar) {
            this.setTopValue();
            this.progressBar.style.strokeDasharray = this.totalLength;
            this.progressBar.style.strokeDashoffset = this.totalLength;

            window.addEventListener('scroll', this.handleScroll.bind(this));
            window.addEventListener('resize', this.setTopValue.bind(this));
        }

        if (this.sidebarNav && this.contentNavLinks) {
            this.stickyDiv = this.sidebarNav.getBoundingClientRect().top + window.pageYOffset - 16;
            this.contentNavigator = this.contentNavLinks.getBoundingClientRect().top + window.pageYOffset;

            window.addEventListener('scroll', this.handleStickyNav.bind(this));
        }
    }

    setTopValue() {
        this.svg.style.top = document.documentElement.clientHeight * 0.5 - (this.svg.getBoundingClientRect().height * 0.5) + 'px';
    }

    handleScroll() {
        this.setProgress();
        this.handleStickyNav();
    }

    setProgress() {
        const clientHeight = document.documentElement.clientHeight;
        const scrollHeight = document.documentElement.scrollHeight;
        const scrollTop = document.documentElement.scrollTop;

        const percentage = scrollTop / (scrollHeight - clientHeight);
        this.pct.innerHTML = Math.round(percentage * 100) + '%';
        this.progressBar.style.strokeDashoffset = this.totalLength - this.totalLength * percentage;
    }

    handleStickyNav() {
        if (window.scrollY >= this.stickyDiv || window.scrollY >= this.contentNavigator) {
            this.sidebarNav.classList.add('fixed-nav');
            this.contentNavLinks.classList.add('fixed-nav');
        } else {
            this.sidebarNav.classList.remove('fixed-nav');
            this.contentNavLinks.classList.remove('fixed-nav');
        }
    }
}

window.addEventListener('load', () => new Sidebar());
